import React from 'react'
import RichTextEditorComponent from '../../../components/employer/lightEntrepreneurs/richTextEditor.component'
import { Controller, useController } from 'react-hook-form'
import { HelperText } from './helperText'
import FormControl from '@material-ui/core/FormControl'

export const HookRichTextEditor = ({
  name,
  control,
  label,
  defaultValue,
  height,
  disabled
}) => {
  const {
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue ?? ''
  })

  return (
    <FormControl error={invalid}>
      <div>
        <span>{label}</span>
        <div style={{ paddingTop: '5px' }}>
          <Controller
            render={({ field: { value, onChange } }) => {
              const handleEditorChange = (editorValue) => {
                onChange(editorValue)
              }
              return (
                <RichTextEditorComponent
                  value={value}
                  onEditorChange={handleEditorChange}
                  height={height}
                  disabled={disabled}
                />
              )
            }}
            name={name}
            control={control}
          />
        </div>
        <HelperText
          invalid={invalid}
          error={error}
          style={{ marginTop: '0px', height: '0px' }}
        />
      </div>
    </FormControl>
  )
}
